import { render } from "./ArticleHandle.vue?vue&type=template&id=5c3bd22b&ts=true"
import script from "./ArticleHandle.vue?vue&type=script&lang=ts"
export * from "./ArticleHandle.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__